import { render, staticRenderFns } from "./CreateSKUModal.vue?vue&type=template&id=81c428a4&scoped=true"
import script from "./CreateSKUModal.vue?vue&type=script&lang=js"
export * from "./CreateSKUModal.vue?vue&type=script&lang=js"
import style0 from "./CreateSKUModal.vue?vue&type=style&index=0&id=81c428a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c428a4",
  null
  
)

export default component.exports